import LineItem from './LineItem';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Testing Note
 * Rendering and readOnly tested in OrderSummary-test.
 * lineItemErrors tested in CheckoutContainer-test as part of validation.
 */
const LineItems = _ref => {
  let {
    currencyCode,
    readOnly,
    lineItemErrors,
    lineItems,
    selectedItems,
    selectionToggles,
    sessionOpen,
    checkoutFeeAdjustment,
    hasFutureCharges,
    taxDisplayConfig
  } = _ref;
  const getIsLastItem = index => {
    return index === lineItems.length - 1;
  };
  const getIsLastFutureItem = index => {
    return hasFutureCharges && index === lineItems.length - 1;
  };
  const getIsSelectable = index => {
    return selectedItems[index] === false && sessionOpen;
  };
  const getIsPreviousItemSelectable = index => {
    return getIsSelectable(index - 1);
  };
  const getIsFirstSelectable = index => {
    return getIsSelectable(index) && !getIsPreviousItemSelectable(index);
  };
  const getIsLastSelectable = index => {
    return getIsSelectable(index) && getIsLastItem(index);
  };
  const getIsNextItemNonSelectable = index => {
    return !getIsLastItem(index) && !getIsSelectable(index + 1);
  };
  return /*#__PURE__*/_jsx(List, {
    marginBlockEnd: "0",
    ordered: true,
    children: lineItems.map((lineItem, i) => /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(View, {
        "data-test-id": `checkout-line-item-${i}`,
        padding: "600",
        backgroundColor: getIsSelectable(i) ? 'fill-transitional-tabs-pressed' : 'fill-surface-default',
        borderBlockStartColor: getIsFirstSelectable(i) ? 'border-core-default' : undefined,
        borderBlockStartWidth: getIsFirstSelectable(i) ? '100' : undefined,
        borderBlockStartStyle: getIsFirstSelectable(i) ? 'solid' : undefined,
        paddingBlockEnd: getIsLastSelectable(i) ? '600' : getIsSelectable(i) ? '400' : '600',
        paddingBlockStart: getIsFirstSelectable(i) ? '600' : getIsSelectable(i) ? '0' : '600',
        borderEndEndRadius: getIsLastFutureItem(i) ? 'transitional-container-alt' : '0',
        borderEndStartRadius: getIsLastFutureItem(i) ? 'transitional-container-alt' : '0',
        children: /*#__PURE__*/_jsx(LineItem, {
          currencyCode: currencyCode,
          error: lineItemErrors[i],
          lineItem: lineItem,
          readOnly: readOnly,
          selected: selectedItems[i],
          toggleSelected: selectionToggles[i],
          sessionOpen: sessionOpen,
          checkoutFeeAdjustment: checkoutFeeAdjustment,
          taxDisplayConfig: taxDisplayConfig
        }, 'id' in lineItem ? lineItem.id : i)
      }), getIsNextItemNonSelectable(i) && /*#__PURE__*/_jsx(HR, {
        inlineSize: "calc(100% - 48px)",
        margin: "0",
        marginInlineStart: "600"
      })]
    }, 'id' in lineItem ? lineItem.id : i))
  });
};
export default LineItems;